import type { ReactNode } from "react";

import { useHasProductTabs } from "src/components/layout/nav/sections/hooks/projects";
import { useTemplateLibraryAccess } from "src/components/template-library/use-template-library-access";
import { Navigate } from "src/router";

type Props = {
  category: "ads" | "email";
  children: ReactNode;
};

export const TemplateLibraryRoute = ({ category, children }: Props) => {
  const hasProductTabs = useHasProductTabs();
  const { showAdTemplates, showEmailTemplates, homePath } =
    useTemplateLibraryAccess();
  const isAllowed = category === "ads" ? showAdTemplates : showEmailTemplates;
  if (hasProductTabs && !isAllowed) {
    return <Navigate to={homePath ?? "/"} replace />;
  }
  return <>{children}</>;
};
